import { Button, Col, Row } from "reactstrap";
import { useState, useRef, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import RotatePhonePopup from "../RotatePhonePopup";
import axios from "axios";
import DarkNoInternet from '../DarkNoInternet';
import DarkNoData from '../DarkNoData';
import { useSnackbar } from "../context/SnackbarContext";

// img
import spinbtn from "../../img/spinbtn.png"
import spinner from "../../img/spinner.png"
import ring from "../../img/spinnerRing.png"
import bottom from "../../img/spinnerbottom.png"
import circle from "../../img/spinnercircle.png"
import pointer from "../../img/spinnerpointer.png"
import rewardbg from "../../img/rewardbg.svg"
import rewardline from "../../img/rewardline.png"
import confetti from "../../img/hotnessconfetti.png"
import line from "../../img/hotnessline.svg"

import NoNetDark from "../../img/NoNetDark.png"
import NouserDark from "../../img/NoUserFoundDark.png";
import { useNavigate } from "react-router-dom";

import spinWin from "../../audio/spinwin.wav";
import { useLanguage } from "../context/Languagecontext";
import { useTranslatedText } from "../../hooks/useTranslatedText";


const Category6 = ({ hint, uploadedImage, originalData, username, category }) => {
    const { lanText, t } = useLanguage();
    const { showSnackbar } = useSnackbar();

    const navigate = useNavigate();
    const urlParams = new URLSearchParams(window.location.search);
    const rewardModal = urlParams.get("reward") === "1";
    const [isSpinning, setIsSpinning] = useState(false);
    const [rotation, setRotation] = useState(0);
    const [selectedIndex, setSelectedIndex] = useState(() => {
        const savedData = sessionStorage.getItem('spinnerRewardData');
        if (savedData) {
            const { index } = JSON.parse(savedData);
            return index;
        }
        return null;
    });
    const [isNewReward, setIsNewReward] = useState(false);
    const [spinnerData, setSpinnerData] = useState([]);
    const [apiTitle, setApiTitle] = useState([]);
    const [apiError, setApiError] = useState(false);
    const [reward, setReward] = useState(rewardModal);
    const [isStopping, setIsStopping] = useState(false);
    const [isSpin, setSpin] = useState(false);
    const [isRenderReady, setIsRenderReady] = useState(false);
    const stopStartTimeRef = useRef(null);
    const initialStopVelocityRef = useRef(6);
    const spinStartTimeRef = useRef(null);
    const targetRotationRef = useRef(0);
    const spinWinAudioRef = useRef(null);

    // Internet, loading, and image states
    const [noInternet, setNoInternet] = useState(false);
    const [imagesLoaded, setImagesLoaded] = useState(false);
    const [spinnerImagesLoaded, setSpinnerImagesLoaded] = useState(false);

    // ── Read noNet/noUser images from localStorage (written by CategoryLink) ──
    const [cachedImages, setCachedImages] = useState({
        noNetDark: null,
        noUserDark: null,
    });
    const [uiImagesReady, setUiImagesReady] = useState(false);

    const spinnerRef = useRef(null);
    const animationFrameRef = useRef(null);
    const spinAudioRef = useRef(null);
    const fullAudioRef = useRef(null);

    const isSmallScreen = window.innerWidth < 380 && window.innerWidth !== 360;

    const data = originalData.question;
    const questionText = Array.isArray(data)
        ? data.find(item => item.category === category)?.question || t.hotness.defaultQuestion
        : t.hotness.defaultQuestion;
    const translatedQuestion = useTranslatedText(questionText, lanText);

    const HotnessId = Array.isArray(data)
        ? data.find(item => item.category === category)?.answer.hotnessId ?? "1"
        : "1";

    const defaultSpinnerData = [
        { name: "Smart", image: "https://lol-image-bucket.s3.amazonaws.com/images/question6/category/UserCardBg-c0aa2729-7a88-4f7f-8881-020da30f10cd.png" },
        { name: "Awkward Flirter", image: "https://lol-image-bucket.s3.amazonaws.com/images/question6/category/UserCardBg-64bcb2d7-e3c6-4ef4-84df-c655b31acb3b.png" },
        { name: "Flirt Vibes", image: "https://lol-image-bucket.s3.amazonaws.com/images/question6/category/UserCardBg-f955175a-37cc-42ee-ab38-69edc88b5144.png" },
        { name: "Naughty", image: "https://lol-image-bucket.s3.amazonaws.com/images/question6/category/UserCardBg-aa97cf63-fcb1-4e95-891a-0c9ac7369668.png" },
        { name: "Lovely", image: "https://lol-image-bucket.s3.amazonaws.com/images/question6/category/UserCardBg-dddfeaf4-592c-4037-8a2d-3b73d58d07a9.png" },
        { name: "Fatty", image: "https://lol-image-bucket.s3.amazonaws.com/images/question6/category/UserCardBg-83a7cb5a-3979-44a6-abe4-b361c1ceac49.png" },
        { name: "Hot", image: "https://lol-image-bucket.s3.amazonaws.com/images/question6/category/UserCardBg-b22277df-c94a-4aff-a1e3-a93b487e43be.png" },
        { name: "Funny", image: "https://lol-image-bucket.s3.amazonaws.com/images/question6/category/UserCardBg-fc6a8a66-a30d-4bac-a531-025ef0c735f8.png" }
    ];

    const getSectionPosition = (index, radius = 48) => {
        const angle = (index * 45);
        const angleInRadians = (angle * Math.PI) / 180;
        const x = Math.cos(angleInRadians - Math.PI / 2) * radius;
        const y = Math.sin(angleInRadians - Math.PI / 2) * radius;
        return {
            left: `calc(50% + ${x}%)`,
            top: `calc(50% + ${y}%)`,
            rotation: angle,
        };
    };

    const getSelectedSection = (currentRotation) => {
        const normalizedRotation = ((currentRotation % 360) + 360) % 360;
        const sectionAngle = 360 / spinnerData.length;
        const sectionIndex = Math.floor(normalizedRotation / sectionAngle);
        return (spinnerData.length - sectionIndex) % spinnerData.length;
    };

    const spins = [
        { rotation: 0, duration: 4000 }
    ];

    const handleSpinClick = () => {
        if (isSpinning) {
            setSpin(false);
            if (animationFrameRef.current) {
                cancelAnimationFrame(animationFrameRef.current);
            }

            if (spinAudioRef.current) {
                spinAudioRef.current.pause();
                spinAudioRef.current.currentTime = 0;
            }
            if (navigator.onLine && fullAudioRef.current) {
                fullAudioRef.current.currentTime = 0;
                fullAudioRef.current.play().catch(err => console.error('Error playing stop sound:', err));
            }

            const currentSection = getSelectedSection(rotation);
            const targetSectionIndex = currentSection;

            const sectionAngle = 360 / spinnerData.length;
            const targetSectionAngle = ((spinnerData.length - targetSectionIndex) % spinnerData.length) * sectionAngle;
            const currentNormalizedRotation = ((rotation % 360) + 360) % 360;

            let rotationDiff = targetSectionAngle - currentNormalizedRotation;
            if (rotationDiff <= 0) {
                rotationDiff += 360;
            }

            function getRandomSpin() {
                const randomIndex = Math.floor(Math.random() * spins.length);
                return spins[randomIndex];
            }
            const selectedSpin = getRandomSpin();
            const additionalRotation = selectedSpin.rotation + rotationDiff;
            const finalRotation = rotation + additionalRotation;

            targetRotationRef.current = finalRotation;
            initialStopVelocityRef.current = 6;
            stopStartTimeRef.current = Date.now();
            setIsStopping(true);

            const currentRotationSnapshot = rotation;

            const decelerateAnimation = () => {
                const elapsed = Date.now() - stopStartTimeRef.current;
                const duration = selectedSpin.duration;
                const progress = Math.min(elapsed / duration, 1);
                const easeOut = 1 - Math.pow(1 - progress, 3);
                const currentRotation = currentRotationSnapshot + (additionalRotation * easeOut);
                setRotation(currentRotation);

                if (progress < 1) {
                    animationFrameRef.current = requestAnimationFrame(decelerateAnimation);
                } else {
                    setRotation(finalRotation);
                    setIsSpinning(false);
                    setIsStopping(false);

                    setTimeout(() => {
                        const selected = getSelectedSection(finalRotation);
                        setSelectedIndex(selected);
                        setIsNewReward(true);

                        sessionStorage.setItem('spinnerRewardData', JSON.stringify({
                            index: selected,
                            spinnerData: spinnerData
                        }));

                        try {
                            if (navigator.onLine && spinWinAudioRef.current) {
                                spinWinAudioRef.current.currentTime = 0;
                                spinWinAudioRef.current.play();
                            }
                        } catch (e) {
                            console.warn("Win audio error:", e);
                        }

                        setReward(true);
                    }, 100);
                }
            };

            decelerateAnimation();
        } else {
            setIsSpinning(true);
            setSpin(true);
            setSelectedIndex(null);
            spinStartTimeRef.current = Date.now();

            const animate = () => {
                setRotation(prev => prev + 5);
                animationFrameRef.current = requestAnimationFrame(animate);
            };

            animate();
        }
    };

    const navigateToNextScreen = async () => {
        if (!navigator.onLine) {
            showSnackbar(t?.common?.nointertoast || "Please turn on internet connection!", "error");
            return;
        }
        const formData = {
            originalData,
            hint,
            uploadedImage,
            translatedQuestion,
            apiTitle,
            reward: spinnerData[selectedIndex]
        };
        sessionStorage.setItem("showContentButton", "true");
        sessionStorage.setItem('hotnessFlowData', JSON.stringify(formData));

        navigate(`/${username || ''}/${category || ''}/hotnesscard`, {
            replace: false
        });
    };

    // Initialize audio elements
    useEffect(() => {
        spinWinAudioRef.current = new Audio(spinWin);
        spinWinAudioRef.current.preload = "auto";
        spinWinAudioRef.current.loop = false;
        spinWinAudioRef.current.load();

        return () => {
            if (spinWinAudioRef.current) {
                spinWinAudioRef.current.pause();
                spinWinAudioRef.current = null;
            }
        };
    }, []);

    useEffect(() => {
        return () => {
            if (animationFrameRef.current) {
                cancelAnimationFrame(animationFrameRef.current);
            }
        };
    }, []);

    useEffect(() => {
        const handleVisibilityChange = () => {
            if (document.hidden) {
                try {
                    if (spinAudioRef.current) {
                        spinAudioRef.current.pause();
                        spinAudioRef.current.currentTime = 0;
                    }
                    if (fullAudioRef.current) {
                        fullAudioRef.current.pause();
                        fullAudioRef.current.currentTime = 0;
                    }
                    if (spinWinAudioRef.current) {
                        spinWinAudioRef.current.pause();
                        spinWinAudioRef.current.currentTime = 0;
                    }
                } catch (e) {
                    console.warn("Audio stop error:", e);
                }

                if (animationFrameRef.current) {
                    cancelAnimationFrame(animationFrameRef.current);
                }
            }
        };

        document.addEventListener("visibilitychange", handleVisibilityChange);

        return () => {
            document.removeEventListener("visibilitychange", handleVisibilityChange);

            try {
                if (spinAudioRef.current) {
                    spinAudioRef.current.pause();
                    spinAudioRef.current.currentTime = 0;
                }
                if (fullAudioRef.current) {
                    fullAudioRef.current.pause();
                    fullAudioRef.current.currentTime = 0;
                }
                if (spinWinAudioRef.current) {
                    spinWinAudioRef.current.pause();
                    spinWinAudioRef.current.currentTime = 0;
                }
            } catch (e) {
                console.warn("Audio cleanup error:", e);
            }
        };
    }, []);

    // ── Read noNetDark / noUserDark from localStorage (written by CategoryLink) ──
    useEffect(() => {
        const noNetDark = localStorage.getItem('noNetImageDark') || NoNetDark;
        const noUserDark = localStorage.getItem('noUserImageDark') || NouserDark;
        setCachedImages({ noNetDark, noUserDark });
        setUiImagesReady(true);
    }, []);

    // ── Fetch spinner data (API URLs used directly, no localStorage caching) ──
    useEffect(() => {
        const checkInternetAndFetchData = async () => {
            if (!navigator.onLine) {
                setNoInternet(true);
                return;
            }

            setSelectedIndex(null);
            setReward(false);
            setSpinnerImagesLoaded(false);
            sessionStorage.removeItem('spinnerRewardData');

            try {
                const response = await axios.post(
                    'https://api.lolcards.link/api/web/hotness',
                    {
                        hotnessId: HotnessId,
                        lanText: lanText,
                    }
                );

                const result = response.data;
                const apiData = result.data || result;

                if (apiData && Array.isArray(apiData) && apiData.length > 0) {
                    setSpinnerData(apiData);
                    setApiTitle(result.title || '');
                } else {
                    setSpinnerData(defaultSpinnerData);
                }

            } catch (error) {
                console.error('Error fetching spinner data:', error.response?.data || error.message);
                setApiError(true);
            }
        };

        checkInternetAndFetchData();
    }, [HotnessId, lanText]);

    // ── Preload spinner images in memory only (no localStorage) ──
    useEffect(() => {
        if (spinnerData.length === 0) return;

        const preloadAll = async () => {
            try {
                await Promise.all(
                    spinnerData.map(
                        item =>
                            new Promise((resolve) => {
                                const img = new Image();
                                img.onload = () => resolve();
                                img.onerror = () => resolve(); // don't block on error
                                img.src = item.image;
                            })
                    )
                );
                requestAnimationFrame(() => {
                    requestAnimationFrame(() => {
                        setSpinnerImagesLoaded(true);
                    });
                });
            } catch {
                setSpinnerImagesLoaded(true);
            }
        };

        preloadAll();
    }, [spinnerData]);

    // ── Show content once ui images and spinner images are both ready ──
    useEffect(() => {
        if (uiImagesReady && spinnerImagesLoaded) {
            setTimeout(() => {
                setImagesLoaded(true);
                requestAnimationFrame(() => {
                    requestAnimationFrame(() => {
                        setIsRenderReady(true);
                    });
                });
            }, 300);
        }
    }, [uiImagesReady, spinnerImagesLoaded]);

    useEffect(() => {
        const isDisabled = isSpinning || isStopping;
        window.dispatchEvent(new CustomEvent('dropdownDisabledState', {
            detail: { disabled: isDisabled }
        }));
    }, [isSpinning, isStopping]);

    const currentNoNetImg = cachedImages.noNetDark;
    const currentNoUserImg = cachedImages.noUserDark;

    if (noInternet) {
        return (
            <DarkNoInternet
                style={{ height: '100vh', background: '#1C1C1C' }}
                t={t?.noData || {}}
                Nouser={currentNoNetImg}
                imgLoaded={!!currentNoNetImg}
            />
        );
    }

    if (apiError) {
        return (
            <DarkNoData
                style={{ height: '100vh', background: '#1C1C1C' }}
                t={t.noData2}
                Nouser={currentNoUserImg}
                username={username}
                category={category}
                imgLoaded={!!currentNoUserImg}
            />
        );
    }


    if (!imagesLoaded || !spinnerImagesLoaded || !isRenderReady || !uiImagesReady) {
        return (
            <div className='GTRegular' style={{ background: "#1C1C1C" , height : "100dvh"}}>
                <div className='h-100 d-flex justify-content-center'>
                    <Row className={`h-100`} style={{ width: "500px", maxWidth: "100vw" }}>
                        <Col className="p-0 d-flex flex-column" style={{ height: '100%' }}>
                            <div
                                className="d-flex justify-content-center align-items-center"
                                style={{ height: isSmallScreen ? '65px' : '90px' }}
                            >
                                <div className="shimmer2" style={{
                                    width: "85%",
                                    height: "20px",
                                    maxWidth: "90vw",
                                    borderRadius: "10px"
                                }}></div>
                            </div>

                            <div className="d-flex justify-content-center align-items-center flex-grow-1 w-100 my-2">
                                <div className="h-100 d-flex justify-content-center align-items-center flex-column">
                                    <div className="position-relative d-flex justify-content-center align-items-center" style={{ width: isSmallScreen ? "88%" : "92%" }}>
                                        <div className="shimmer-element2" style={{
                                            width: "320px",
                                            aspectRatio: "1",
                                            borderRadius: "50%",
                                            maxWidth: "450px",
                                            position: "relative"
                                        }}></div>
                                    </div>
                                </div>
                            </div>

                            <div
                                className="d-flex justify-content-center align-items-center"
                                style={{ height: isSmallScreen ? '90px' : '120px' }}
                            >
                                <div
                                    className="shimmer-element2"
                                    style={{
                                        width: "clamp(150px, 10vw, 150px)",
                                        height: "clamp(15px, 10vw, 100px)",
                                        borderRadius: "12px"
                                    }}
                                ></div>
                            </div>
                        </Col>
                    </Row>
                </div>
            </div>
        );
    }

    return (
        <motion.div className='GTRegular bg-black' style={{ height: "100dvh" }}>
            <div className='h-100 d-flex justify-content-center'>
                <Row className={`category6img-bg h-100`} style={{ width: "500px", maxWidth: "100vw" }}>
                    <Col className="p-0 d-flex flex-column" style={{ height: '100%' }}>
                        <div
                            className="d-flex justify-content-center align-items-center pt-42"
                            style={{ height: isSmallScreen ? '85px' : '90px' }}
                        >
                            <div className="text-center pt-4" style={{ maxWidth: "90vw" }}>
                                <p
                                    className="text-white lh-sm mx-auto ps-2 m-0"
                                    style={{
                                        fontSize: "clamp(18px, 4.5vw, 20px)",
                                        display: "-webkit-box",
                                        WebkitLineClamp: 3,
                                        WebkitBoxOrient: "vertical",
                                        overflow: "hidden"
                                    }}
                                >
                                    {t?.common?.que || 'Que:'} {' '} {translatedQuestion || questionText}
                                </p>
                            </div>
                        </div>

                        <motion.div
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            transition={{ duration: 0.3 }}
                            className="d-flex justify-content-center align-items-center flex-grow-1 w-100 my-2"
                        >
                            <div className="h-100 d-flex justify-content-center align-items-center flex-column">
                                <div className="position-relative" style={{ width: isSmallScreen ? "82%" : "88%", zIndex: 2 }}>
                                    <div
                                        ref={spinnerRef}
                                        style={{
                                            transform: `rotate(${rotation}deg)`,
                                            transition: 'none',
                                        }}
                                    >
                                        <img src={spinner} alt="spinner" className="img-fluid" />

                                        <motion.div
                                            initial={{ opacity: 0 }}
                                            animate={{ opacity: 1 }}
                                            transition={{ duration: 0.3 }}
                                            className="position-absolute"
                                            style={{
                                                top: "50.5%",
                                                left: "50%",
                                                width: "55%",
                                                height: "55%",
                                                transform: "translate(-50%, -50%)",
                                            }}
                                        >
                                            {spinnerData.map((section, index) => {
                                                const position = getSectionPosition(index);
                                                return (
                                                    <div
                                                        key={index}
                                                        className="position-absolute"
                                                        style={{
                                                            left: position.left,
                                                            top: position.top,
                                                            transform: `translate(-50%, -50%) rotate(${position.rotation}deg)`,
                                                            display: 'flex',
                                                            flexDirection: 'column',
                                                            alignItems: 'center',
                                                            justifyContent: 'space-around',
                                                            zIndex: 3,
                                                            height: "45%",
                                                            width: "45%",
                                                        }}
                                                    >
                                                        <p
                                                            className="text-white GTBold m-0 text-center holtwood"
                                                            style={{
                                                                fontSize: 'clamp(12px, 2.3vw, 13px)',
                                                                whiteSpace: 'pre-line',
                                                                lineHeight: "12px"
                                                            }}
                                                        >
                                                            {(() => {
                                                                const name =
                                                                    section.name.charAt(0).toUpperCase() + section.name.slice(1);
                                                                const maxChars = 9;

                                                                if (name.includes(" ")) {
                                                                    const words = name.split(" ");
                                                                    let line1 = "";
                                                                    let line2 = "";
                                                                    for (let word of words) {
                                                                        if ((line1 + word).length <= maxChars) {
                                                                            line1 += (line1 ? " " : "") + word;
                                                                        } else {
                                                                            line2 += (line2 ? " " : "") + word;
                                                                        }
                                                                    }
                                                                    return line2 ? `${line1}\n${line2}` : line1;
                                                                }

                                                                return name.length > maxChars
                                                                    ? name.slice(0, maxChars) + "\n" + name.slice(maxChars)
                                                                    : name;
                                                            })()}
                                                        </p>

                                                        <div
                                                            className="rounded-circle overflow-hidden"
                                                            style={{
                                                                width: '45%',
                                                                height: '45%',
                                                                position: 'relative',
                                                            }}
                                                        >
                                                            <img
                                                                src={section.image}
                                                                alt={section.name}
                                                                style={{
                                                                    width: '100%',
                                                                    height: '100%',
                                                                    objectFit: 'cover',
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                );
                                            })}
                                        </motion.div>
                                    </div>

                                    <div
                                        className="position-absolute"
                                        style={{
                                            left: '50%',
                                            top: '50.5%',
                                            transform: 'translate(-50%, -50%)',
                                            width: '16.5%',
                                            height: '16.5%',
                                            zIndex: 4,
                                        }}
                                    >
                                        <img
                                            src={circle}
                                            alt="circle"
                                            style={{ width: '100%', height: '100%', objectFit: 'contain' }}
                                        />
                                    </div>

                                    <div
                                        className="position-absolute"
                                        style={{
                                            left: '50%',
                                            top: '50%',
                                            transform: 'translate(-50%, -50%)',
                                            width: '103%',
                                            height: '103%',
                                            zIndex: 4,
                                        }}
                                    >
                                        <img
                                            src={ring}
                                            alt="ring"
                                            style={{ width: '100%', height: '100%', objectFit: 'contain' }}
                                        />
                                    </div>

                                    <div
                                        className="position-absolute"
                                        style={{
                                            left: '50%',
                                            top: '5%',
                                            transform: 'translate(-50%, -50%)',
                                            width: '12.5%',
                                            height: '12.5%',
                                            zIndex: 4,
                                        }}
                                    >
                                        <img
                                            src={pointer}
                                            alt="pointer"
                                            style={{ width: '100%', height: '100%', objectFit: 'contain' }}
                                        />
                                    </div>
                                </div>

                                <div style={{ width: "50%", marginTop: isSmallScreen ? "-30px" : "-20px" }}>
                                    <img src={bottom} alt="bottom" className="img-fluid" />
                                </div>
                            </div>
                        </motion.div>

                        <div
                            className="d-flex justify-content-center align-items-center"
                            style={{ height: isSmallScreen ? '90px' : '120px' }}
                        >
                            <div
                                onClick={isStopping ? null : handleSpinClick}
                                className={`mx-auto d-flex justify-content-center align-items-center ${isSmallScreen ? "pb-3" : "pb-4"} text-white ${isStopping ? 'opacity-50' : ''}`}
                                style={{
                                    width: isSmallScreen ? "85px" : "105px",
                                    height: isSmallScreen ? "85px" : "105px",
                                    flex: "0 0 63%",
                                    backgroundImage: `url(${spinbtn})`,
                                    backgroundSize: "contain",
                                    backgroundRepeat: "no-repeat",
                                    backgroundPosition: "center",
                                    userSelect: "none",
                                    transition: "all 0.2s",
                                    WebkitTouchCallout: "none",
                                    WebkitUserSelect: "none",
                                    WebkitTapHighlightColor: "transparent",
                                    touchAction: "none",
                                    cursor: isStopping && reward ? 'not-allowed' : 'pointer',
                                    transform: isSpin && !isStopping ? 'scale(0.95)' : 'scale(0.95)',
                                    pointerEvents: isStopping && reward ? 'none' : 'auto',
                                    animation: isSpin ? "pulse2 1.5s infinite" : "none"
                                }}
                            >
                                <p className="GTBold"
                                    style={{
                                        fontSize: isSmallScreen ? "21px" : "25px",
                                        whiteSpace: "nowrap",
                                    }}
                                >
                                    {isSpin ? (t?.hotness?.stop || "Stop") : (t?.hotness?.spin || "Spin")}
                                </p>
                            </div>
                        </div>
                    </Col>
                </Row>
            </div>

            <AnimatePresence>
                {reward && selectedIndex !== null && spinnerData.length > 0 && spinnerData[selectedIndex] && (
                    <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        transition={{ duration: isNewReward ? 0.5 : 0 }}
                        className="position-fixed top-0 start-0 w-100 h-100 d-flex flex-column align-items-center justify-content-center"
                        style={{
                            zIndex: 99999,
                            backgroundColor: 'rgba(0, 0, 0, 1)',
                            backdropFilter: 'blur(5px)',
                            overflow: 'hidden'
                        }}
                    >
                        <div className="poistion-relative d-flex flex-column align-items-center justify-content-center" style={{ width: "500px", maxWidth: "100vw" }}>
                            <div
                                className="position-relative"
                                style={{
                                    width: '600px',
                                    height: '650px',
                                    marginTop: "-120px",
                                }}
                            >
                                <motion.div
                                    className="position-absolute d-flex justify-content-center align-items-center"
                                    style={{
                                        top: '39%',
                                        left: '37%',
                                        transform: 'translate(-50%, -50%)',
                                        zIndex: 4
                                    }}
                                    initial={{ opacity: 0, scale: 0 }}
                                    animate={{ opacity: 1, scale: 1 }}
                                    transition={{
                                        delay: isNewReward ? 0.4 : 0,
                                        duration: 0.3,
                                        ease: "easeOut"
                                    }}
                                >
                                    <div
                                        className="rounded-circle overflow-hidden"
                                        style={{ width: "160px", height: "160px" }}
                                    >
                                        <img
                                            src={spinnerData[selectedIndex].image}
                                            alt={spinnerData[selectedIndex].name}
                                            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                        />
                                    </div>
                                </motion.div>

                                <div className="position-absolute d-flex justify-content-center align-items-center w-100 h-100"
                                    style={{ top: '50%', left: '50%', transform: 'translate(-50%, -50%)', zIndex: 2 }}>
                                    <img src={rewardbg} alt="bg" />
                                </div>

                                <div className="position-absolute d-flex justify-content-center align-items-center w-100 h-100"
                                    style={{ top: '50%', left: '50%', transform: 'translate(-50%, -50%)', zIndex: 1 }}>
                                    <motion.img
                                        src={line}
                                        animate={{ rotate: 360 }}
                                        transition={{ duration: 3, repeat: Infinity, ease: "linear" }}
                                    />
                                </div>

                                <div className="position-absolute d-flex justify-content-center align-items-center w-100 h-100"
                                    style={{ top: '50%', left: '50%', transform: 'translate(-50%, -50%)', zIndex: 3 }}>
                                    <img src={confetti} alt="reward" style={{ width: "58%" }} />
                                </div>
                            </div>

                            <div
                                className="position-absolute d-flex align-items-start justify-content-center"
                                style={{
                                    bottom: 0,
                                    left: "50%",
                                    top: "58%",
                                    transform: "translate(-50%)",
                                    width: "500px",
                                    maxWidth: "100vw"
                                }}
                            >
                                <div className="w-100 text-center py-3 d-flex flex-column align-items-center gap-3">
                                    <p
                                        className="text-white GTBold m-0"
                                        style={{ fontSize: "clamp(30px, 4vw, 32px)" }}
                                    >
                                        {spinnerData[selectedIndex].name}
                                    </p>

                                    <img
                                        src={rewardline}
                                        alt="reward"
                                        className="mb-3"
                                        style={{ width: "65%" }}
                                    />
                                </div>
                            </div>

                            <Button
                                onClick={() => navigateToNextScreen()}
                                className="position-absolute rounded-pill border-0 mx-auto text-white GTMedium"
                                style={{
                                    padding: "10px 1px",
                                    height: "50px",
                                    width: "min(380px, 85vw)",
                                    maxWidth: "380px",
                                    background: "linear-gradient(to left, #FD9060, #FB2317)",
                                    pointerEvents: 'auto',
                                    cursor: 'pointer',
                                    touchAction: 'none',
                                    WebkitTapHighlightColor: 'transparent',
                                    bottom: '20px',
                                    left: '50%',
                                    transform: 'translateX(-50%)',
                                    zIndex: 5
                                }}
                            >
                                <span className='GTMedium'
                                    style={{
                                        fontSize: "clamp(21px, 4.5vw, 27px)",
                                        whiteSpace: "nowrap",
                                    }}
                                >
                                    {t?.common?.claim || "Claim"}
                                </span>
                            </Button>
                        </div>
                    </motion.div>
                )}
            </AnimatePresence>

            <RotatePhonePopup excludeWhen={[]} />
        </motion.div>
    );
};

export default Category6; 